import { apiGet, apiPost, apiPut } from "../utils/apiConnector"
import { createAction, handleActions } from "redux-actions"
import {
  getTariffsGroupsApi,
  getTariffsGroupApi,
  getTariffApi,
  postTariffPaymentApi,
} from "../config/apiUrls"

const defaultState = {
  groups: [],
  tariffs: [],
  url: "",
}

const setGroups = createAction("SET_GROUPS")
const setTariffs = createAction("SET_TARIFFS")
const setUrl = createAction("SET_URL")

const reducers = handleActions(
  {
    [setGroups]: (state, { payload }) => ({
      ...state,
      groups: payload,
    }),
    [setTariffs]: (state, { payload }) => {
      const tariffs = [...state["tariffs"]]
      payload.map((el) => {
        tariffs.push(el)
      })
      return { ...state, tariffs: tariffs }
    },
    [setUrl]: (state, { payload }) => ({
      ...state,
      url: payload,
    }),
  },
  defaultState,
)

export default reducers

// Thunk
export function getGroups() {
  return (dispatch) => {
    return apiGet(getTariffsGroupsApi)
      .onOk((res) => {
        dispatch(setGroups(res.data.data))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        //
      })
      .startSingle()
  }
}

export function getTariffs(id) {
  return (dispatch) => {
    return apiGet(getTariffsGroupApi + id)
      .onOk((res) => {
        dispatch(setTariffs(res.data.data))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        //
      })
      .startSingle()
  }
}

export function getAllTariffs() {
  return (dispatch, getState) => {
    dispatch(getGroups())
    const {
      payment: { groups },
    } = getState()
    groups.map((el) => {
      dispatch(getTariffs(el.ID))
    })
  }
}

export function payTariff(tid, psCode) {
  return (dispatch, getState) => {
    const {
      profile: { id },
    } = getState()
    const json = {
      theTariff: tid,
      theOwner: id,
      customSum: 0,
      psCode: psCode,
      fio: "",
      tel: "",
    }
    return apiPost(postTariffPaymentApi, JSON.stringify(json))
      .onOk((res) => {
        dispatch(setUrl(res.data.payurl))
      })
      .useDefaultErrorHandlers(dispatch)
      .afterAll(() => {
        //
      })
      .startSingle()
  }
}
